import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../hooks/hooks";
import PageLoader from "../../../../components/PageLoader";
import AccountSettings from "../../../../components/venture/AccountSettings";
import { selectnpsubscriptionsListItems } from "../../../../redux/np-subscriptions/selector";
import { npsubscriptions } from "../../../../redux/np-subscriptions/action";
import Table from "../../../../common/components/table";

const VentureNp = () => {
  const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const subscriptionsItems = useSelector(selectnpsubscriptionsListItems)
  const navigate = useNavigate()
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },

      {
        field: 'LicenseId', headerName: 'License Id', searchField: 'LicenseId', filter: true,
        filterType: 'text'
      },
      { field: 'OrganizationUnitId', headerName: 'Organization unit' },
      { field: 'NPSubscriptionName', headerName: 'NPSubscription Name' },
      { field: 'ModifiedOnUtc', headerName: 'Modified Date' },
      { field: 'CreatedOnUtc', headerName: 'Created Date' },


    ]);
  }

  const fetchNpSubscriptionsList = () => {
    dispatch(npsubscriptions.list({
      url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/platform-management/np-subscriptions/list`, entity: 'npsubscriptions', jsonData: {
         "Context": {
            "Subscription": "ONE",
            "Domain": "ONE",
            "SubDomains": [],
            "Network": "Venture",
            "Application": "Venture",
            "Channel": "CSP"
          },
        "Records": [
          {
            "Id": 0
          }
        ],
      }
    }))
  }

  useEffect(() => {
    createColumnDefs()
    fetchNpSubscriptionsList()
  }, [pageData, pageSize])

  const handleReloadData = () => {
    fetchNpSubscriptionsList();
  }
  const additionButtons: any = [

    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];
  return (
    <>
      <div className="h-screen flex flex-col justify-between items-stretch bg-white">
        <div className="flex flex-row ">
          <AccountSettings />
          <div className="w-3/4  justity-center items-center">
            <div className="w-full  rounded-lg  flex flex-col  text-black p-5">
              <div className="flex flex-col items-start justify-between w-full space-y-3 border-b p-2 border-blue-500">
                <div className="flex w-full flex-col items-start justify-between text-xl" >
                  NP Subscriptions
                </div>

              </div>
              {subscriptionsItems?.isLoading ? <PageLoader /> :

                <Table
                  columnData={columnDefs} rowData={subscriptionsItems?.result?.items} setPageData={setPageData}
                  checkboxConfig={{
                    allowMultiSelect: true,
                    defaultSelectedIds: [],
                    isDisabled: false,
                    keyColumn: 'Name',
                  }} headingName=""
                  setPageSize={setPageSize} paginationData={subscriptionsItems?.result?.pagination} additionButtons={additionButtons} />

              }
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VentureNp;


